export default "__VITE_ASSET__CEjGKItr__"